document.addEventListener('DOMContentLoaded', () => {
    const skeleton = document.querySelector('.ysw-skeleton-search-magic');
    const container = document.querySelector('#ysw-search-vertical-container');

    if (!skeleton || !container) return;

    const checkIfContentLoaded = () => {
        const itemBoxes = container.querySelectorAll('.item-box');

        if (Array.from(itemBoxes).some((box) => box.children.length > 0)) {
            skeleton.style.display = 'none';
        }
    };

    checkIfContentLoaded();

    const observer = new MutationObserver(checkIfContentLoaded);
    observer.observe(container, { childList: true, subtree: true });
});
